import { useInterval } from 'lib/hooks';
import { useEffect, useRef } from 'react';
import { getSoftLogin } from './api';

/**
 * We want to periodically refresh the user's softLoggedIn cookie to keep them logged in.
 * We do this so we can keep refreshing the cookie out of the softLoggedIn middleware on the backend.
 * This should only be done if a user isn't logged in with auth0 (i.e. they are softLoggedIn).
 */
export const useSoftLogin = (enabled: boolean) => {
  const useSoftLoginRef = useRef<boolean>(false);

  useInterval(
    async () => {
      if (useSoftLoginRef.current) {
        await getSoftLogin();
      }
    },
    60 * 60 * 1000
  );

  useEffect(() => {
    useSoftLoginRef.current = enabled;
  }, [enabled]);
};
